import { CHANGE_LANGUAGE } from "../constants/languageConstant"

export const updateLanguage = (data) => (dispatch) => {
    dispatch({type: CHANGE_LANGUAGE, payload: data})
    window.localStorage.setItem("language", data)
}